import "./contact";
import "./scroll-to-top";
import "./header-scroll";
import "./audio-player";
import ThemeToggle from "./theme-toggle";
import HeaderProfile from "./header-profile";
import ReadingControls from "./reading-controls";

new ThemeToggle();
new HeaderProfile();
new ReadingControls();
